class Sticker {

    constructor(id, serie, order, customer, packages, agency, nameAgency, name,
                address, cp, county, state, delivery, nameDelivery, phone, employee,
                nameEmployee, check, created, id_customer, way_pay, expedicionAsigna,
                dateDelivery, counterDelivery, dropshipping, print) {
        this.id = id;
        this.serie = (serie) ? serie.toUpperCase() : serie;
        this.order = order;
        this.customer = customer;
        this.packages = packages;
        this.weight = undefined;
        this.delivery = delivery;
        this.nameDelivery = nameDelivery;
        this.agency = agency;
        this.nameAgency = nameAgency;
        this.name = name;
        this.address = address;
        this.cp = cp;
        this.county = county;
        this.state = state;
        this.phone = phone;
        this.listCustomerAdress = [];
        this.boxes = [];
        this.created = created;
        this.isNew = false;
        this.scanned = false;
        this.dropshipping = (dropshipping ? dropshipping : false);
        this.employee = employee;
        this.nameEmployee = nameEmployee;
        this.check = (check ? check : false);
        this.way_pay = way_pay;
        this.id_customer = id_customer;
        this.expedicionAsigna = expedicionAsigna;
        this.dateDelivery = dateDelivery;
        this.counterDelivery = counterDelivery;
        this.overrideRoute = false;
        this.print = (print ? print : false);
        this.tradename = null;
        this.phonesDefault = [];
        this.comment = null;
        this.ruta_fecha = null;
        this.tracking_comentario = null;
    }

    getOrder(){
        return this.serie + '-' + this.order;
    }

    mapFromData(data) {

        this.id =
            data.id ??
            `${data.ejercicio}-${data.serie}-${data.albaran}-${data.linea}`;

        this.serie = data.serie ?? '';
        this.albaran = data.albaran ?? '';

        this.id_cliente = data.id_cliente ?? '';
        this.cliente = data.cliente ?? '';
        this.clienteFinal = data.clienteFinal === true;

        this.id_agencia = data.id_agencia ?? '';
        this.agencia = data.agencia ?? '';

        this.delivery = data.rutaReparto ?? '';
        this.nameDelivery = data.ruta ?? '';
        this.zona = data.zona ?? '';

        this.nombre = data.nombre ?? '';
        this.direccion = data.direccion ?? '';
        this.cp = data.cp ?? '';
        this.poblacion = data.poblacion ?? '';
        this.provincia = data.provincia ?? '';
        this.telefono = data.telefono ?? '';

        this.bultos = Number(data.bultos ?? 0);
        this.peso = Number(data.peso ?? 0);

        this.empleado = data.empleado ?? '';
        this.usuario = data.usuario ?? '';

        this.comprobado = Boolean(data.comprobado);
        this.dropshipping = Boolean(data.dropshipping);
        this.imprimir = Boolean(data.imprimir);
        this.counterDelivery = data.id_ruta ?? '';

        this.expedicionAsigna = data.expedicion_asigna ?? '';
        this.tracking_estado = data.tracking_estado ?? '';
        this.tracking_descripcion = data.tracking_descripcion ?? '';
        this.tracking_fechaestado = data.tracking_fechaestado
            ? new Date(data.tracking_fechaestado).toLocaleString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            })
            : null;

        this.creado = data.creado ? new Date(data.creado) : null;
        this.modificado = data.modificado ? new Date(data.modificado) : null;

        this.ruta_fecha = data.rutaReparto ? new Date(data.rutaReparto?.fecha).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'}) : null;

        this.isNew = data.isNew ?? false;
        this.tracking_comentario = data.tracking_comentario ?? null;
        this.tracking_destino = data.tracking_destino ?? null;

        return this;
    }

    static from(data) {
        return new Sticker().mapFromData(data);
    }
}

export default Sticker;